export default __webpack_public_path__ + "static/media/NCMalaysia.3ab7bb47.png";